<script setup lang="ts">
interface Props {
  bg?: 'dark' | 'light' | 'white'
  blurBg?: boolean
  layout?: 'horizontal' | 'vertical'
  headerColorHex?: string
}

const { LocalConfigurationStore } = stores()
const cardHeaderColorHex = computed(
  () => LocalConfigurationStore.value?.siteInfo?.cardHeaderColorHex
)
const props = withDefaults(defineProps<Props>(), {
  bg: 'light',
  blurBg: false,
  layout: 'vertical',
})

const dinamicClasses = computed(() => ({
  'bg-blur': props.blurBg,
  [`bg-${props.bg}`]: true,
}))

const dinamicHeaderClasses = computed(() => {
  return {
    'p-2': props.layout === 'horizontal',
    'p-3 md:p-4': props.layout === 'vertical',
    'bg-surface-950': isNil(cardHeaderColorHex),
  }
})

const dinamicClassesContent = computed(() => ({
  grid: props.layout === 'vertical',
  'flex items-stretch ': props.layout === 'horizontal',
}))
</script>

<template>
  <div
    class="relative rounded-lg p-1 app-card shadow-md bg-white"
    :class="dinamicClasses"
  >
    <div
      class="app-card-content"
      :class="dinamicClassesContent"
    >
      <div
        v-if="$slots.header"
        class="flex items-center justify-center rounded-md text-white app-card-header"
        :class="dinamicHeaderClasses"
        :style="{
          'background-color': headerColorHex ?? cardHeaderColorHex,
        }"
      >
        <slot name="header" />
      </div>
      <slot />
    </div>
  </div>
</template>
